var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.as === 'switch')?_c('v-switch',{attrs:{"required":_vm.config.required,"label":_vm.config.label,"dark":""},model:{value:(_vm.booleanValue),callback:function ($$v) {_vm.booleanValue=$$v},expression:"booleanValue"}}):_c('v-checkbox',{attrs:{"required":_vm.config.required,"label":_vm.config.label,"dark":""},model:{value:(_vm.booleanValue),callback:function ($$v) {_vm.booleanValue=$$v},expression:"booleanValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594633e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Boolean.vue
// module id = null
// module chunks = 